var _defs, _path, _circle, _path2, _rect, _rect2, _rect3, _rect4, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconActivePasive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{clip-path:url(#clip-path-3);}.cls-5{clip-path:url(#clip-path-4);}.cls-6{fill:#126aa7;}.cls-7{fill:#edbd2f;}.cls-8{fill:#fff;}.cls-9{fill:#1469a6;}.cls-10{fill:#e1ce2b;}.cls-11{fill:#d04090;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310,169a9.89,9.89,0,1,1,0-7.4,7.57,7.57,0,0,1,4.32-3.11,15.1,15.1,0,1,0,0,13.58A7.79,7.79,0,0,1,310,169"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.11,165.32a4.54,4.54,0,1,1-4.53-4.56,4.55,4.55,0,0,1,4.53,4.56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.71,165.28a4.54,4.54,0,1,1-4.53-4.56,4.55,4.55,0,0,1,4.53,4.56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.53,165.62a15.65,15.65,0,0,0,2.13,4l.07.07,0,.07a6.4,6.4,0,0,0,4.83,2.16,6.55,6.55,0,0,0,4.59-1.89,6.41,6.41,0,0,0,1.89-4.56,6.55,6.55,0,0,0-1.89-4.59,6.41,6.41,0,0,0-4.56-1.89,6.52,6.52,0,0,0-6.15,4.36v0c-.1.2-.44,1.15-.95,2.3M302.43,159a7.45,7.45,0,0,0-1.25-.14,6.46,6.46,0,0,0-6.48,6.45,6.55,6.55,0,0,0,1.89,4.59,6.41,6.41,0,0,0,4.56,1.89,6.6,6.6,0,0,0,4.83-2.13l.1-.1a15.93,15.93,0,0,0,2.16-4c-.47-1.15-.81-2.09-.91-2.33l0-.1a6.52,6.52,0,0,0-4.86-4.19m-2.77,13.88a7.67,7.67,0,1,1,8.75-10l0,.07c.14.34.27.74.44,1.15.17-.41.3-.81.44-1.15v0a7.67,7.67,0,0,1,7.26-5.17,7.5,7.5,0,0,1,5.4,2.26,7.61,7.61,0,0,1,2.23,5.44,7.5,7.5,0,0,1-2.26,5.4,7.68,7.68,0,0,1-11.14-.34l0,0a12.67,12.67,0,0,1-2-3.31,13.68,13.68,0,0,1-2,3.31l0,0a7.7,7.7,0,0,1-5.74,2.53,7.17,7.17,0,0,1-1.42-.14"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Iconos - Cards - Kolo interno") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M41.77,9.12a.78.78,0,0,0-1.1,0l-3.75,3.75H29.74a.78.78,0,0,0-.44.13L10.09,27.24a.78.78,0,0,0,.42,1.43.78.78,0,0,0,.44-.13L30,14.42h7.27a.78.78,0,0,0,.55-.23l4-4a.77.77,0,0,0,0-1.1Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 10.91,
    cy: 25.1,
    r: 3.84
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M12.3,26.28a1,1,0,0,1-.3.19.92.92,0,0,1-.34.07.71.71,0,0,1-.41-.13,1.06,1.06,0,0,1-.32-.36,1.25,1.25,0,0,1-.63-.16,1.18,1.18,0,0,1-.44-.43,1.17,1.17,0,0,1,.45-1.64,1.34,1.34,0,0,1,1.26,0,1.16,1.16,0,0,1,.61,1,1.18,1.18,0,0,1-.1.49,1.16,1.16,0,0,1-.28.39,1.2,1.2,0,0,1-.42.25.49.49,0,0,0,.35.19.72.72,0,0,0,.42-.19Zm-2-1a.8.8,0,0,0,.29.29.76.76,0,0,0,.39.11.75.75,0,0,0,.39-.11.78.78,0,0,0,.28-.29.79.79,0,0,0,.1-.4.78.78,0,0,0-.1-.4.77.77,0,0,0-.28-.29.76.76,0,0,0-.39-.1.79.79,0,0,0-.68.39.8.8,0,0,0,0,.8Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 7.08,
    y: 30.65,
    width: 7.67,
    height: 13.26,
    rx: 0.74,
    ry: 0.74
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 16.49,
    y: 27.3,
    width: 7.67,
    height: 16.61,
    rx: 0.78,
    ry: 0.78
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 25.9,
    y: 21.67,
    width: 7.67,
    height: 22.24,
    rx: 0.88,
    ry: 0.88
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 35.31,
    y: 17.39,
    width: 7.67,
    height: 26.51,
    rx: 0.89,
    ry: 0.89
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.42,8.28l3.39,3.17a.18.18,0,0,0,.31-.11l.53-3.9a.18.18,0,0,0-.22-.21L39.51,8A.18.18,0,0,0,39.42,8.28Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActivePasive);
export default __webpack_public_path__ + "static/media/icon-active-pasive.9d04c4c18f8cef2602838353c3628742.svg";
export { ForwardRef as ReactComponent };